import { css } from '@emotion/css'
import { fontFamily, fontSize, spacing } from '../../styles'
import { colors } from '../../themes'

const styles = {
  fieldset: css({
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.jumbo,
  }),

  radioInputs: css({
    display: 'flex',
    flexWrap: 'wrap',

    // Negative margin to compensate for
    // spacing between each nested RadioInput
    marginBottom: -spacing.default,
  }),

  errorMessage: css({
    marginTop: spacing.small,
  }),
}

export default styles
